import React from "react";
import whatsappIcon from "../Images/whatsapp-icon.png"; // use your icon

const WhatsAppButton = () => {
  const phoneNumber = "+917016591400"; // 👈 include country code (no +)

  return (
    <a
    href={`https://wa.me/${phoneNumber}?text=Can%20I%20get%20more%20info%20about%20your%20products`}
      className="whatsapp-float"
      target="_blank"
      rel="noopener noreferrer"
    >
      <img src={whatsappIcon} alt="WhatsApp Chat" />
    </a>
  );
};

export default WhatsAppButton;